import aclNames from '../acl/AclName';

export const CURRENCY_PUZZLE = 1;
export const CURRENCY_DOCUMENTS = 2;
export const CURRENCY_DATA_USAGE = 3;

const refreshUrls = {
  post: [
    /crms\/\d+\/activations/,
    /staffs\/\d+\/activations/,
    /crms\/recharge/,
    /users\/access-tokens/,
    /bookkeepings\/invoices$/,
    /files/,
  ],
  get: [
    /files\/ocr\/\d+/,
  ],
};

export const isSystemBalanceRefreshRequired = (method, url) => {
  const methodUrls = refreshUrls?.[method] ?? [];
  return methodUrls.some((regex) => regex.test(url));
};

export const CONFIG = {
  [CURRENCY_PUZZLE]: {
    acl: aclNames.CrmSectionSystemBalancePuzzle,
  },
  [CURRENCY_DOCUMENTS]: {
    acl: aclNames.CrmSectionSystemBalanceDocuments,
  },
  [CURRENCY_DATA_USAGE]: {
    acl: aclNames.CrmSectionSystemBalanceDataUsage,
  },
};
